export const camelizeFromKebab = string => string.replace(/-./g, match => match[1].toUpperCase());

export const normalizeSpecialCharacters = string =>
  string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .toLowerCase();

export const kebabToTitleCase = str =>
  str
    .replace(/-/g, ' ')
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase());
